import { Formik, Form } from "formik";
import { ListGroup, ListGroupItem, Spinner } from "react-bootstrap";

import Panel from "../../Panel";
import { Heading, Intro } from "../../Typography";
import ProfileFormFields from "../../EntryFormFields";
import PictureInput from "../../../../../components/PictureInput";
import { Field, SubmitButton } from "../../../../../components/forms";
import useCompetitorDetailScreen from "./useCompetitorDetailScreen";
import Avatar from "../../../../../components/Avatar";
import { MainButton } from "../../../../../components/button";

const CompetitorDetailScreen = () => {
  const {
    profile,
    profiles,
    initialValues,
    onSubmit,
    schema,
    canChangeCategory,
    competition,
    setProfile,
    isCreatingUser,
    setIsCreatingUser,
    isEditing,
    onRemove,
    isLeagueEntryLoading,
  } = useCompetitorDetailScreen();
  return (
    <Panel>
      <Heading>Add a competitor</Heading>
      <Intro>
        {profile || isCreatingUser ? (
          "Add info for this competitor"
        ) : profiles?.length ? (
          "Select an existing profile or add a new one"
        ) : (
          <br />
        )}
      </Intro>
      {!profiles || !competition || isLeagueEntryLoading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {!profile && !isCreatingUser ? (
            <>
              <div className="mb-3">
                <MainButton onClick={() => setIsCreatingUser(true)}>
                  Add new profile
                </MainButton>
              </div>
              <ListGroup>
                {profiles.map((profileItem) => (
                  <ListGroupItem
                    onClick={() => setProfile(profileItem)}
                    key={profileItem.uuid}
                  >
                    <div className="d-flex align-items-center">
                      <div className="me-2">
                        <Avatar
                          user={{
                            name:
                              profileItem.firstName +
                              " " +
                              profileItem.lastName,
                            pictureUrl: profileItem.pictureUrl,
                            uuid: profileItem.uuid,
                          }}
                          size={40}
                        />
                      </div>
                      <div className="flex">
                        <strong>
                          {profileItem.firstName} {profileItem.lastName}
                        </strong>
                      </div>
                    </div>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </>
          ) : (
            <>
              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={schema}
              >
                <Form>
                  <Field name="profilePicture" className="text-center">
                    <PictureInput />
                    <div style={{ fontSize: 13 }} className="fst-italic">
                      (Optional - will be displayed on leaderboards)
                    </div>
                  </Field>
                  <ProfileFormFields
                    competition={competition}
                    canChangeCategory={canChangeCategory}
                    withAgeGender={true}
                  />
                  <SubmitButton>
                    {isEditing ? "Save" : "Add competitor"}
                  </SubmitButton>
                </Form>
              </Formik>
              {isEditing ? (
                <MainButton
                  variant="outline-danger"
                  className="mt-2"
                  onClick={onRemove}
                >
                  Remove Competitor
                </MainButton>
              ) : null}
            </>
          )}
        </>
      )}
    </Panel>
  );
};

export default CompetitorDetailScreen;
